import React, { createRef, RefObject } from 'react'
import ReactDOM from 'react-dom'
import { BaseNotifier } from './baseNotifier'
import BannerNotification from '../elementals/bannerNotification'

// Compatibility layer for React 16/17 and React 18+
type RootLike = {
  render: (element: React.ReactNode) => void
  unmount: () => void
}

let createRootCompat: ((container: HTMLElement) => RootLike) | null = null

try {
  // Try to import createRoot for React 18+
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const ReactDOMClient = require('react-dom/client')
  if (ReactDOMClient && ReactDOMClient.createRoot) {
    createRootCompat = ReactDOMClient.createRoot
  }
} catch {
  // React 18 not available, will use legacy API
}

// TODO: Remove this compatibility layer once React 18 migration is complete
const createRoot = (container: HTMLElement): RootLike => {
  if (createRootCompat) {
    // React 18+
    return createRootCompat(container)
  }

  // React 16/17 fallback
  return {
    render: (element: React.ReactNode) => {
      ReactDOM.render(element as React.ReactElement, container)
    },
    unmount: () => {
      ReactDOM.unmountComponentAtNode(container)
    },
  }
}

class PageBannerNotifier extends BaseNotifier {
  private _containerDomNode: HTMLElement | null = null
  private _root: RootLike | null = null

  constructor() {
    super()
  }

  /**
   * For this initialize we pass in a containerRef such that the caller can specify
   * the node to attach the notification to (in the page)
   */
  initialize(containerRef?: RefObject<HTMLElement>): void {
    const notificationSystem = createRef<typeof BannerNotification>()

    this._containerDomNode = containerRef?.current ?? null
    if (this._containerDomNode) {
      this._root = createRoot(this._containerDomNode)
      this._root.render(
        //@ts-ignore
        <BannerNotification ref={notificationSystem} isOverlay={false} />
      )
    }
    super.initialize(notificationSystem)
  }

  open(options: Record<string, unknown>): void {
    // open the notification system with the options defaulted using based prepareOptions function - may differ in future
    super.open(super.prepareOptions(options))
  }

  destroy(): void {
    // unmount and remove the notification from the container
    if (this._root) {
      this._root.unmount()
      this._root = null
    }
    super.destroy()
  }
}

export { PageBannerNotifier }
